import { Box, CardContent, LinearProgress, linearProgressClasses, Stack, styled, Typography } from "@mui/material";
import React from "react";
import { colours } from "../../StyleConstants";
import { useSelector } from "react-redux";
import { selectGlobusTransferStatus } from "../data-wrangler/globusSlice";


const GlobusTransferProgress = () => {
    const transferStatus = useSelector(selectGlobusTransferStatus);

    const progressNumber = transferStatus.pageCount > 0
        ? Math.round(transferStatus.page / transferStatus.pageCount * 100)
        : 0;
    const renderText = (value: string) => {
        return value === "error" ? "Error" : `${value}%`;
    };

    const BorderLinearProgress = styled(LinearProgress)(() => ({
        height: "16px",
        borderRadius: "8px",
        [`&.${linearProgressClasses.colorPrimary}`]: {
            backgroundColor: transferStatus.complete ? colours.success.success : colours.notifications.info20
        },
        [`& .${linearProgressClasses.bar}`]: {
            borderRadius: 5,
            backgroundColor: transferStatus.complete ? colours.success.success : colours.notifications.info
        },
    }));

    return (
        <CardContent>
            <Typography align="center" sx={{ fontWeight: 600, marginBottom: 3 }} variant="h5">
                {transferStatus.complete
                    ? "Your Globus Transfer Is Submitted "
                    : "Your Globus Transfer Is Preparing."
                }
            </Typography>
            <Typography align="center" sx={{ marginBottom: 3 }} variant="h6">
                {transferStatus.complete
                    ? (
                        <a href={"https://app.globus.org/activity"} target={"_blank"} rel="noreferrer">
                            Monitor you transfer progress on Globus
                        </a>
                    ) : "This could take several minutes."}
            </Typography>
            <Box
                sx={{
                    p: '20px',
                    display: 'flex',
                    width: '100%',
                    alignItems: 'center',
                    marginY: '1rem'
                }}
                className="copy-box">
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '95%', gap: 2 }}>
                    <Stack
                        flexDirection="row"
                        justifyContent="center"
                        alignItems="center"
                        gap={1}
                    >
                        <BorderLinearProgress
                            variant="determinate"
                            value={progressNumber}
                            sx={{ flexGrow: 2 }}
                        />
                        <Typography
                            fontSize="12px"
                            color={transferStatus.complete ? colours.success.success : colours.notifications.info}
                            textAlign="center">
                            {renderText(progressNumber.toString())}
                        </Typography>
                    </Stack>
                </Box>
            </Box>
        </CardContent>
    )
}

export default GlobusTransferProgress;